<template>
 <b-card class="mb-3">
  <template #header>
    <div class="d-flex justify-content-between align-items-center w-100">
      
      <h3 class="mb-0 font-weight-bold">
        Detalhamento
      </h3>

      <div class="d-flex">
        
        <b-button size="sm" class="mr-1"
          :variant="selectedHour === null ? 'primary' : 'outline-primary'"
          @click="selectedHour = null">
          Todas
        </b-button>

        <b-button size="sm" class="mr-1"
          :variant="selectedHour === '08:20' ? 'primary' : 'outline-primary'"
          @click="selectedHour = '08:20'">
          08:20
        </b-button>

        <b-button size="sm" class="mr-1"
          :variant="selectedHour === '09:20' ? 'primary' : 'outline-primary'"
          @click="selectedHour = '09:20'">
          09:20
        </b-button>

        <b-button size="sm"
          :variant="selectedHour === '13:00' ? 'primary' : 'outline-primary'"
          @click="selectedHour = '13:00'">
          13:00
        </b-button>
        <div class="d-flex align-items-center ml-2">
          <b-form-input
            v-model="establishmentFilter"
            placeholder="Filtrar por EC"
            size="sm"
            style="max-width: 180px;"
          />
        </div>
      </div>

    </div>
  </template>
    <b-table
      :items="filteredDetails"
      :fields="fields"
      :per-page="perPage"
      :current-page="page"
      responsive
      show-empty
      small
      striped
      hover
      :tbody-tr-class="rowClass"
      :busy="isLoading"
       class="text-center"
        empty-text=""
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
        </div>
      </template>
      <template #empty>
        <div class="text-center py-3">
          <p v-if="noDataMessage" class="text-danger font-weight-bold" style="font-size: 1rem;">
            {{ noDataMessage }}
          </p>
          <p v-else class="text-muted">
            Sem registros para exibir.
          </p>
        </div>
      </template>

      <template #cell()="data">
        <span v-if="data.field.key === 'bank'">
          {{ truncate(data.value, 30) }}
        </span>
        <span v-else>
          {{ formatCell(data.value) }}
        </span>
      </template>
    </b-table>

    <b-pagination
      v-if="!isLoading"
      v-model="page"
      :per-page="perPage"
      :total-rows="totalRows"
      align="center"
      size="sm"
      class="mt-2 text-center"
    />
  </b-card>
</template>

<script>
import { BCard, BTable, BPagination, BButton, BSpinner, BFormInput} from "bootstrap-vue";
import { formatDate, formatTaxId, formatValue, } from "@/utils";

export default {
  name: "DetailTable",
  components: { BCard, BTable, BPagination, BButton, BSpinner, BFormInput },
  props: {
    details: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    noDataMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      selectedHour: null,
       establishmentFilter: "",
      hourOptions: [
        { value: null, text: "Todas" },
        { value: "08:20", text: "08:20" },
        { value: "09:20", text: "09:20" },
        { value: "13:00", text: "13:00" }
      ],
      fields: [
        { key: "liquidationArrangementId", label: "ID Liquidação", thStyle: { minWidth: "120px" }, }, 
        { key: "merchantPaymentId", label: "ID do Pagamento", thStyle: { minWidth: "130px" }, },
        { key: "paymentScheduleDate", label: "Data Agendamento", thStyle: { minWidth: "140px" }, formatter: "formatDateOnly", },
        { key: "paymentDate",  label: "Data do Pagamento", thStyle: { minWidth: "140px" },  formatter: "formatDateOnly", },
        { key: "sendDate",  label: "Data de Envio", thStyle: { minWidth: "140px" },  formatter: "formatDateTime",  },
        { key: "returnDate", label: "Data de Retorno", thStyle: { minWidth: "140px" }, formatter: "formatDateOnly", },
        { key: "taxId",  label: "CNPJ/CPF",  thStyle: { minWidth: "200px" }, formatter: "formatTaxId", },
        { key: "establishmentId",  label: "ID Estabelecimento",  thStyle: { minWidth: "130px" },  },
        { key: "paymentAmount", label: "Valor (R$)", thStyle: { minWidth: "120px" }, formatter: "formatValue",},
        { key: "isCercPayment", label: "Pagamento CERC",  thStyle: { minWidth: "120px" },  formatter: "formatBoolean",  },
        { key: "channel", label: "Canal"},
        { key: "arrangement", label: "Arranjo", thStyle: { minWidth: "120px" },  },
        { key: "returnMessage",  label: "Mensagem de Retorno", thStyle: { minWidth: "400px" },  },
        { key: "waitingReturn",  label: "Aguardando Retorno",  thStyle: { minWidth: "140px" }, formatter: "formatBoolean",  },
        { key: "type", label: "Tipo de Conta", thStyle: { minWidth: "140px" } },
        { key: "bank", label: "Nome do Banco", thStyle: { minWidth: "400px" } },
        { key: "agency", label: "Agência", thStyle: { minWidth: "120px" } },
        { key: "accountNumber", label: "Conta", thStyle: { minWidth: "120px" }, }, 
        { key: "favoredName", label: "Nome do Favorecido", thStyle: { minWidth: "300px" }, },
      ],
    };
  },

  computed: {
    totalRows() {
      return this.filteredDetails.length;
    },

   filteredDetails() {
    let result = this.details;

    if (this.selectedHour) {
      result = result.filter(item => {
        if (!item.sendDate) return false;

        const date = new Date(item.sendDate);
        const time = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

        return time === this.selectedHour;
      });
    }

    if (this.establishmentFilter) {
      result = result.filter(item => {
        return String(item.establishmentId)
          .toLowerCase()
          .includes(this.establishmentFilter.toLowerCase());
      });
    }

    return result;
  }
  },
  methods: {
    truncate(value, length = 20) {
      if (!value) return "-";
      const str = String(value);
      return str.length > length ? str.substring(0, length) + "..." : str;
    },

    formatDateTime(value) {
      if (!value) return "-";
      return formatDate(value, "dd/MM/yyyy HH:mm");
    },

    formatDateOnly(value) {
      if (!value) return "-";
      return formatDate(value, "dd/MM/yyyy");
    },

    formatValue(value) {
      if (value === null || value === undefined) return "-";
      return formatValue(value);
    },

    formatCell(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return value;
    },

    formatTaxId(value) {
      if (!value) return "-";
      return formatTaxId(value);
    },

    formatBoolean(value) {
      if (value === null || value === undefined) return "-";
      return value === 1 ? "Sim" : "Não";
    },

   rowClass(item) {
  if (!item) return "";

  if (
    item.returnMessage ===
    "Não existe relacionamento cadastrado para o participante x arranjo de pagamento informado"
  ) {
    return "text-danger font-weight-bold";
  }

  if (
    item.returnMessage === "Liquidacao pendente - Sem resposta ID"
  ) {
    return "text-warning font-weight-bold";
  }

  return "";
}
  },
};
</script>